import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { color } from '@core-ds/primitives';
import { Toolbox } from '@core-ds/icons/24';
import Dropdown from './dropdown';
import Workbench from '../../../workbench';

const Container = styled.div`
   width: 350px;
   text-align: left;
`;

const Icon = styled(Toolbox)`
   cursor: pointer;
   color: ${color.gray4};
`;

const mapStateToProps = state => ({
   workbenchHtml: state.headerState.workbenchHtml,
});

class WorkbenchDropdown extends Component {
   componentDidMount() {
      window.Workbench = new Workbench();
   }

   // Since Workbench isn't React, we need to add the event listeners
   // after the dropdown HTML is added.
   addEventListeners = () => {
      window.Workbench.addEventListeners(this.refs.workbenchRef);
   };

   render() {
      return (
         <Dropdown
            icon={<Icon id="workbenchDropdownToggle" aria-label="my workbench" focusable="false" />}
            onMount={this.addEventListeners}
         >
            <Container
               id="workbench"
               className="hydra-workbench"
               ref="workbenchRef"
               dangerouslySetInnerHTML={{ __html: this.props.workbenchHtml }}
            />
         </Dropdown>
      );
   }
}

export default connect(mapStateToProps)(WorkbenchDropdown);
